/* eslint-disable no-bitwise */
import _now from 'lodash/now';
import _random from 'lodash/random';

/**
 * Usage:
 *    uuid()
 *
 * Produces:
 *    '9716498c-45df-47d2-8099-3f678446d776'
 *
 * Generates an RFC 4122 version 4 uuid
 * @see http://stackoverflow.com/a/8809472
 * @returns {String} the generated uuid
 */
export default function uuid() {
  let d = _now();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + _random(16)) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
